import { render, staticRenderFns } from "./AuthorSelect.vue?vue&type=template&id=00643740"
import script from "./AuthorSelect.vue?vue&type=script&lang=js"
export * from "./AuthorSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports